var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00071 3.65967C8.00071 5.6809 6.35977 7.31982 4.33529 7.32126C2.30124 7.32269 0.661738 5.68138 0.667005 3.64865C0.672272 1.6327 2.32135 -0.00334839 4.34487 5.14631e-06C6.36312 0.00335868 8.00071 1.64276 8.00071 3.65967Z",
    fill: "#178FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.59139 7.38086C3.43583 8.56705 5.241 8.55699 7.07874 7.38805C7.07874 7.59932 7.07874 7.78568 7.07874 7.97204C7.07874 8.59436 7.07443 9.2162 7.08018 9.83852C7.08449 10.3099 6.87189 10.6525 6.46488 10.8642C6.04639 11.0817 5.63077 11.0377 5.25297 10.7564C4.94748 10.5294 4.65444 10.286 4.33746 10.0349C4.03197 10.274 3.73031 10.5183 3.42051 10.7512C2.81287 11.2063 1.97541 10.9931 1.68045 10.3104C1.64023 10.218 1.59665 10.1164 1.5957 10.0187C1.58851 9.15153 1.59139 8.28488 1.59139 7.38086Z",
    fill: "#178FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/BadgeIcon.5837965c2e4324dac485112e39c75922.svg";
export { ForwardRef as ReactComponent };